class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// Shopify's full search excludes collections; retrieve category matches separately.
(async function () {
  const container = document.querySelector('[data-search-collections]');
  if (!container) return;
  try {
    const params = new URLSearchParams({
      q: container.dataset.query,
      section_id: 'predictive-search',
      'resources[type]': 'collection',
      'resources[limit]': '10',
    });
    const response = await fetch(`${routes.predictive_search_url}?${params}`);
    if (!response.ok) return;
    const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
    const categories = documentResult.querySelector('[data-section="collections"]');
    if (!categories) return;
    // On the full page these are ordinary links, not autocomplete options.
    categories.querySelectorAll('[role]').forEach((element) => element.removeAttribute('role'));
    categories.querySelectorAll('[aria-selected]').forEach((element) => element.removeAttribute('aria-selected'));
    categories.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    categories.querySelectorAll('[tabindex]').forEach((element) => element.removeAttribute('tabindex'));
    container.append(categories);
    container.hidden = false;
    document.querySelector('[data-search-no-results]')?.remove();
  } catch (error) {
    // Keep the server-rendered search usable if category suggestions fail.
  }
})();
